import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LabelList } from 'recharts'
import { RevenueVsBudgetRow } from "models/consulting-revenue-budget"
import { formatCurrency } from "utils/tools"

interface RevenueBudgetChartProps {
    title: string
    data: RevenueVsBudgetRow[]
}

const RevenueBudgetChart = ({ title, data }: RevenueBudgetChartProps) => (
    <div style={{ width: "100%" }}>
        <h4 className="text-muted mb-2">{title}</h4>
        <div style={{ width: "100%", height: 500 }}>
            <ResponsiveContainer width="100%" height="100%">
                <BarChart data={data} margin={{ right: 10, left: 50, bottom: 20 }}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis
                        tickFormatter={(v: number) => formatCurrency(v, "CAD", 0)}
                        domain={[
                            (min: number) => Math.min(0, Math.floor(min * 2)),
                            (max: number) => Math.ceil(max * 1.15)
                        ]}
                    />
                    <Tooltip formatter={(v: number) => formatCurrency(v)} />
                    <Legend />
                    <Bar dataKey="actual" name="Revenue" fill="#00b050">
                        <LabelList dataKey="actual" position="top" formatter={(v: number) => formatCurrency(v, "CAD", 0)} />
                    </Bar>
                    <Bar dataKey="budget" name="Budget" fill="#4472c4">
                        <LabelList dataKey="budget" position="top" formatter={(v: number) => formatCurrency(v, "CAD", 0)} />
                    </Bar>
                    <Bar dataKey="variance" name="Variance" fill="#ff66ff">
                        <LabelList dataKey="variance" position="top" formatter={(v: number) => formatCurrency(v, "CAD", 0)} />
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    </div>
)

export default RevenueBudgetChart
